import { GetterTree } from "vuex";
import { RootState } from "../types";
import { IEmailComposerState } from "./types";

export const getters: GetterTree<IEmailComposerState, RootState> = {};
